// Texto del progreso de la auto-conciliación de una operación indeterminada.
// El cronograma es progresivo (0s, 10s, 20s, 45s, 90s y 180s tras el UNKNOWN).
const secondsLeft = (iso, now) => {
  const due = new Date(iso).getTime();
  if (Number.isNaN(due)) return null;
  return Math.max(0, Math.round((due - now) / 1000));
};

export const humanizeSeconds = (seconds) => {
  if (seconds >= 60) {
    const min = Math.floor(seconds / 60);
    const rest = seconds % 60;
    return rest ? `${min} min ${rest} s` : `${min} min`;
  }
  return `${seconds} s`;
};

export const autoReconcileLabel = (info, now = Date.now()) => {
  if (!info) return "";
  const attempts = Number(info.attempts) || 0;
  const max = Number(info.max_attempts) || 0;
  if (info.finished && !info.next_attempt_at) {
    return info.exhausted
      ? `Lecturas agotadas (${attempts}/${max}): pasó a revisión manual`
      : `Conciliación finalizada (${attempts}/${max})${info.last_level ? ` · ${info.last_level}` : ""}`;
  }
  if (info.next_attempt_at) {
    const next = Number(info.next_attempt_number) || attempts + 1;
    const left = secondsLeft(info.next_attempt_at, now);
    const when = left === null || left === 0 ? "ahora" : `en ${humanizeSeconds(left)}`;
    return `Confirmando con el proveedor · comprobación ${next}/${max} ${when}`;
  }
  return `Conciliación reintentada ${attempts}/${max}${info.last_level ? ` · ${info.last_level}` : ""}`;
};
